import { useEffect, useState } from 'react'

import { faHand } from '@fortawesome/pro-regular-svg-icons'

import { Nudge } from '@infura/packages.ui/Nudge'

const REQUEST_URL = 'https://pagead2.googlesyndication.com/pagead/js/adsbygoogle.js'
const EVENTS_URL = 'https://events.launchdarkly.com/events'

export default function AdblockerDetectModal() {
  const [AdsBlockerEnabled, setAdsBlockerEnabled] = useState(false)

  const refreshPage = () => {
    window.location.reload()
  }

  useEffect(() => {
    const requests = [fetch(REQUEST_URL, { method: 'HEAD', mode: 'no-cors' })]
    // @ts-ignore
    if (typeof window !== 'undefined' && window?.navigator?.brave) {
      requests.push(fetch(EVENTS_URL, { method: 'POST', mode: 'no-cors' }))
    }
    Promise.all(requests)
      .then(() => {
        setAdsBlockerEnabled(false)
      })
      .catch(() => {
        setAdsBlockerEnabled(true)
      })
  }, [])

  if (AdsBlockerEnabled) {
    return (
      <div className='pb-8'>
        <Nudge
          options={[
            {
              buttonText: 'Disable and refresh',
              clickButton: refreshPage,
              description:
                'To maintain the security of our platform, please disable your ad blocker. Account registration may fail.',
              icon: faHand,
              id: '0',
              title: 'Adblocker detected'
            }
          ]}
          theme='warning'
        />
      </div>
    )
  }

  return <></>
}
